import React, { useState } from 'react'
import { Wrapper, BarStrip, ProgressBar, ModalComponent, StepperItem } from '../_components'
import Table from '../_components/Table'
import data from '../fixtures'
import Axios from 'axios'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { setApproveModal } from '../_slices/AppSlice'


const ProgressField = record => {
    return (
      <div className="flex w-full items-center justify-center">
        <ProgressBar value={record.value}/>
        <div className="text-xs mx-2">
            {`${record.value}%`}
        </div>
      </div>
    )
}

const ActionField = record => {
  // const dispatch = useDispatch()

  // if( localStorage.getItem( "role" ) === "APPROVER" ) {
  //   return (
  //     ( parseInt( record.row.original?.stage ) === 5 && parseInt( record.row.original?.progress ) === 80 ) && 
  //       ( <div onClick={async () => {
  //       let payload = JSON.stringify( record.row.original )
  //       await localStorage.setItem( "ApprovalPayload", payload )
  //       await dispatch( setApproveModal( { 
  //         approvalFlag: true, 
  //         title: "Approve" 
  //       } ) )
  //     } } className="cursor-pointer w-auto py-1 px-2 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
  //       {`Approve`}
  //     </div> )
  //   )
  // }
  const handleClick = async id => {
    await localStorage.setItem( "applicationId", id )
    await localStorage.setItem( "link", "display")
    window.location.reload()
  }

  if( localStorage.getItem( "role" )?.toUpperCase() === "APPROVER" ) {
    return (
      <div onClick={() => handleClick( record.value )} className="uppercase cursor-pointer bg-green-700 text-xs text-center px-2 py-1 rounded text-white">
        {"Approve"}
      </div> 
    )
  }
}

const steps = [
  "Pending",
  "Actioned"
]

export default function AllApproval( { product } ) {
  const Columns = React.useMemo( () => [
    {
      Header: "#",
      accessor: "recordId"
    },
    {
      Header: "Registered Name of Applicant",
      accessor: "applicant"
    },
    {
      Header: "Email Address",
      accessor: "email_address"
    },
    {
      Header: "Annual Gross Income(UGX)",
      accessor: "annual_income"
    },
    {
        Header: "Progress",
        accessor: "progress",
        Cell: ProgressField
      },
    {
        Header: "Action",
        accessor: "id",
        Cell: ActionField
    }
   
  ] )
  const dispatch = useDispatch()
  const state = useSelector( state => { 
    return {
      approvalFlag: state.application.approvalModal?.approvalFlag,
      title: state.application.approvalModal?.title,
    }
  })
  
  const [ records, setRecords ] = React.useState( [] )
  const [ loading, setLoading ] = React.useState( true )
  const [ tag, setTag ] = useState( "Pending" )

  React.useEffect( () => {
    if( loading ) {
        fetchApplications()
    }
  },[ loading ])

  const fetchApplications = async () => {
    try {
      const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication` ) 
      if( response.data ) {
       const results = response.data.map( ( result, index ) => {
        return {
            recordId: `${index+1}`,
            progress: result.progress,
            stage: result.stage,
            applicant: result.trading_name,
            email_address: result.created_by,
            date: moment( result.created_at ).format( "DD MMM, YYYY" ),
            annual_income: result.annual_turnover,
            id: result.id
        }
       } ).filter( record => parseInt( record.stage ) === 4 && localStorage.getItem( "role" ) === "APPROVER" )

      
       setRecords( results )
       setLoading( false )
      }
    } catch (error) {
      alert( "Server error occured." )
      setLoading( false )
    }
  }

  const handleApprove = async () => {
    // try {
    //   const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/updateITRecord`, {
    //     id: state.id,
    //     progress: parseInt( state.progress ) + 15,
    //     stage: 7
    //   } )
    //   if( response.data ) {
    //     alert( response.data.message )
    //     await dispatch( setApprovalModal( { 
    //       flag: false
    //     } ))
    //     return window.location.reload()
    //   }
    // } catch (error) {}
    let payload = JSON.parse( localStorage.getItem( "ApprovalPayload" ))

      try {
        const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/itcoverify`, {
          id: payload.id,
          progress: parseInt( payload.progress ) + 20,
          stage: parseInt( payload.stage ) + 1,
          status: "APPROVED"
          // task: "Schedule_Audit",
          // comment: "Audit has been scheduled",
          // created_by: localStorage.getItem( "email" ),
          // email_address: state.email
        } )
        if( response.data ) {
          dispatch( setApproveModal( { approvalFlag: false, title: "" } ) )
          alert( response.data.message )
          return window.location.reload()
        }
      } catch (error) {}
  }


  return (
    <Wrapper>
        <div className="flex flex-col h-full">
          <BarStrip />
          <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
            <div className="px-5 py-2 text-sm bg-white">
              {`Pending Approval List - Under Process of IT Service Provider`}
            </div>
            <div className="flex flex-col justify-center w-full bg-white">
             <div className="w-full flex flex-row border-b border-gray-500 rounded-sm">
                {/* tabs */}
                {steps.map( ( item, index ) => {
                  return (
                  <StepperItem 
                    edge={index === 0} 
                    active={tag.toUpperCase() === item?.toUpperCase()} 
                    key={item} 
                    label={item} 
                    onPress={() => {
                      return setTag( item )
                    } } />
                  )
                } )}
              </div>
              <Table 
                label="Application Details"
                columns={Columns}
                data={records}
              />
            </div>
          </div>
        </div>
        <ModalComponent title={state.title} open={state.approvalFlag} handleOpen={() => dispatch( setApproveModal( { approvalFlag: false, title: "" } ) )}>
          {/* <div className="cursor-pointer" >Close</div> */}
          <div className="grid grid-cols-1 w-[700px]">
            
            {`Approve`}
            
            <div className="flex items-center">
              <button onClick={() => dispatch( setApproveModal( { approvalFlag: false, title: "" } ) )} className="bg-blue-700 w-20 text-white text-xs my-2 px-2 py-1 mx-2" type="button">
                {`Cancel`}
              </button>
              <button onClick={handleApprove} className="bg-green-700 w-20 text-white text-xs my-2 px-2 py-1" type="button">
                {`Submit`}
              </button>
            </div>
          </div>
        </ModalComponent>
    </Wrapper>
  )
}
